import { h } from 'preact';
import useFormStore from '../../store/useFormStore';
import './ProgressStepsArrow.css';

export default function ProgressStepsArrow() {
  const currentScreen = useFormStore((state) => state.currentScreen);
  const stepsMetadata = useFormStore((state) => state.stepsMetadata);
  const jumpToScreen = useFormStore((state) => state.jumpToScreen);
  const isShortLeadForm = useFormStore((state) => state.selectedEstimateType === 'on_site_estimate_short');

  // Filter steps based on short lead form status
  const filteredSteps = isShortLeadForm
    ? stepsMetadata.filter((step) =>
        step.key !== 'configure-services' && step.key !== 'schedule-service'
      )
    : stepsMetadata;

  const currentStepIndex = filteredSteps.findIndex((step) => step.key === currentScreen);

  return (
    <div className="progress-steps-arrow max-w-full mx-auto my-2 xl:my-4">
      <div className="progress-steps-arrow__row">
        {filteredSteps.map((step, index) => {
          const state =
            index === currentStepIndex ? 'active' : index < currentStepIndex ? 'complete' : 'upcoming';

          const clickable = state === 'complete';

          // Use sequential numbering (index + 1) for visual display
          const displayNumber = index + 1;

          return (
            <div
              key={step.key}
              className="stepChevron"
              data-state={state}
              data-clickable={clickable ? 'true' : 'false'}
              onClick={() => clickable && jumpToScreen(step.key)}
              role={clickable ? 'button' : undefined}
              tabIndex={clickable ? 0 : undefined}
              onKeyDown={(e) => {
                if (!clickable) return;
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  jumpToScreen(step.key);
                }
              }}
            >
              <span className="stepChevron__badge">
                {state === 'complete' ? '✓' : displayNumber}
              </span>
              <span className="stepChevron__title">{step.title}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
